import {useCallback, useMemo} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {selectLiners} from '~/CreateFabricGreetingCard/reducers/fabricTemplate/selectors';
import {selectLinerId} from '~/CreateFabricGreetingCard/reducers/fabricDesign/selectors';
import {UPDATE_DESIGN_OPTIONS} from '~/CreateFabricGreetingCard/reducers/fabricDesign/constants';

export const useLiners = () => {
  const dispatch = useDispatch();
  const liners = useSelector(selectLiners);
  const linerId = useSelector(selectLinerId);

  const linerIcons = useMemo(
    () => liners.map(({media}) => media.find(({label}) => label === 'icon').url),
    [liners]
  );

  const onLinerChange = useCallback(
    (icon) => {
      const selected = liners.find(
        ({media}) => media.find(({label}) => label === 'icon').url === icon
      );
      dispatch({
        type: UPDATE_DESIGN_OPTIONS,
        payload: {linerId: selected.id, premiumFeaturesPristine: false},
      });
    },
    [liners]
  );

  const selectedLiner = useMemo(() => {
    const selected = liners.find(({id}) => id === linerId);
    if (selected) {
      const image = selected.media.find(({label}) => label === 'image').url;
      const icon = selected.media.find(({label}) => label === 'icon').url;
      return {...selected, image, icon};
    }
  }, [liners, linerId]);

  return {linerIcons, onLinerChange, selectedLiner};
};
